// AddProductPage.styles.js

export const styles = {
    container: {
        margin: '10px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    pageHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '2rem',
        paddingBottom: '1.5rem',
        borderBottom: '2px solid #e2e8f0'
    },
    title: {
        fontSize: '2rem',
        color: '#1a202c',
        margin: 0,
        fontWeight: '700'
    },
    successMessage: {
        background: 'linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%)',
        color: '#155724',
        padding: '1rem',
        borderRadius: '10px',
        marginBottom: '1.5rem',
        fontWeight: '600',
        textAlign: 'center'
    },
    errorMessage: {
        background: 'linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%)',
        color: '#721c24',
        padding: '1rem',
        borderRadius: '10px',
        marginBottom: '1.5rem',
        fontWeight: '600'
    },
    compressingMessage: {
        background: 'linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)',
        color: '#856404',
        padding: '1rem',
        borderRadius: '10px',
        marginBottom: '1.5rem',
        fontWeight: '600',
        textAlign: 'center'
    },
    formSection: {
        borderBottom: '1px solid #e2e8f0'
    },
    sectionTitle: {
        fontSize: '1.5rem',
        color: '#2d3748',
        marginBottom: '1.5rem',
        margin: '0 0 1.5rem 0',
        fontWeight: '700'
    },
    formRow: {
        display: 'flex',
        gap: '1.5rem',
        marginBottom: '1.5rem',
        flexWrap: 'wrap'
    },
    formGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem',
        flex: '1 1 calc(50% - 0.75rem)',
        minWidth: '250px'
    },
    label: {
        fontWeight: '600',
        color: '#2d3748',
        fontSize: '0.95rem'
    },
    required: {
        color: '#e53e3e'
    },
    input: {
        padding: '0.75rem',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '1rem',
        fontFamily: 'inherit',
        transition: 'all 0.3s',
        outline: 'none',
        boxSizing: 'border-box'
    },
    textarea: {
        padding: '0.75rem',
        border: '2px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '1rem',
        fontFamily: 'inherit',
        resize: 'vertical',
        minHeight: '100px',
        transition: 'all 0.3s',
        outline: 'none',
        boxSizing: 'border-box'
    },
    dragDropArea: {
        border: '2px dashed #cbd5e0',
        borderRadius: '12px',
        padding: '3rem 2rem',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.3s',
        marginBottom: '1.5rem'
    },
    dragDropContent: {
        pointerEvents: 'none'
    },
    dragDropTitle: {
        fontSize: '1.25rem',
        color: '#2d3748',
        margin: '0.5rem 0',
        fontWeight: '600'
    },
    dragDropText: {
        color: '#718096',
        margin: '0.5rem 0 1rem 0',
        fontSize: '0.95rem'
    },
    fileInput: {
        display: 'none'
    },
    selectBtn: {
        padding: '0.75rem 1.5rem',
        background: 'linear-gradient(135deg, #667eea 0%, #f59e0b 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '0.95rem',
        transition: 'all 0.3s',
        pointerEvents: 'auto'
    },
    imageCounter: {
        padding: '0.75rem 1rem',
        background: '#eef2ff',
        borderRadius: '8px',
        color: '#667eea',
        fontWeight: '600',
        marginBottom: '1rem',
        textAlign: 'center'
    },
    imagesGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
        gap: '1rem',
        marginTop: '1rem'
    },
    imageCard: {
        border: '2px solid #e2e8f0',
        borderRadius: '12px',
        overflow: 'hidden',
        transition: 'all 0.3s',
        backgroundColor: 'white'
    },
    imagePreview: {
        position: 'relative',
        aspectRatio: '1',
        overflow: 'hidden',
        backgroundColor: '#f7fafc'
    },
    previewImg: {
        width: '100%',
        height: '100%',
        objectFit: 'cover'
    },
    primaryBadge: {
        position: 'absolute',
        top: '0.5rem',
        right: '0.5rem',
        fontSize: '1.5rem',
        background: 'white',
        borderRadius: '50%',
        width: '2.5rem',
        height: '2.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
    },
    imageActions: {
        display: 'flex',
        gap: '0.5rem',
        padding: '0.75rem',
        flexDirection: 'column'
    },
    btnPrimary: {
        padding: '0.5rem',
        background: 'linear-gradient(135deg, #667eea 0%, #f59e0b 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '0.85rem',
        transition: 'all 0.3s'
    },
    btnRemove: {
        padding: '0.5rem',
        background: '#fed7d7',
        color: '#c53030',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontWeight: '600',
        fontSize: '0.85rem',
        transition: 'all 0.3s'
    },
    formActions: {
        display: 'flex',
        gap: '1rem',
        justifyContent: 'flex-end',
        padding: '1.5rem 2rem',
        background: '#f7fafc',
        flexWrap: 'wrap'
    },
    btnCancel: {
        padding: '0.75rem 1.5rem',
        background: 'white',
        color: '#667eea',
        border: '2px solid #667eea',
        borderRadius: '10px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s'
    },
    btnSubmit: {
        padding: '0.75rem 1.5rem',
        background: 'linear-gradient(135deg, #667eea 0%, #f59e0b 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s'
    },
    // Add these to your existing styles in AddProductPage.styles.js

    stepContainer: {
        padding: '2rem',
        textAlign: 'center'
    },

    stepContent: {
        maxWidth: '600px',
        margin: '0 auto',
        padding: '2rem',
        background: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    },

    stepDescription: {
        fontSize: '1.1rem',
        color: '#4a5568',
        marginBottom: '2rem'
    },

    stepActions: {
        display: 'flex',
        gap: '1rem',
        justifyContent: 'center',
        flexWrap: 'wrap'
    },

    btnSecondary: {
        padding: '0.75rem 1.5rem',
        background: 'white',
        color: '#667eea',
        border: '2px solid #667eea',
        borderRadius: '10px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s'
    },

    btnSuccess: {
        padding: '0.75rem 1.5rem',
        background: 'linear-gradient(135deg, #48bb78 0%, #38a169 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s'
    },

    stepIndicator: {
        background: '#e2e8f0',
        padding: '0.5rem 1rem',
        borderRadius: '20px',
        fontWeight: '600',
        color: '#4a5568'
    },

    stepText: {
        fontSize: '0.9rem'
    },

    filterSection: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '1rem',
        marginTop: '1rem'
    },

    filterGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: '0.5rem'
    }
};

export const mediaQueries = {
    mobile: '@media (max-width: 768px)',
    tablet: '@media (max-width: 1024px)',
    desktop: '@media (min-width: 1025px)'
};

// Responsive styles window.innerWidth
export const getResponsiveStyles = () => {
    if (window.innerWidth <= 768) {
        return {
            container: {
                ...styles.container,
                padding: '1rem'
            },
            pageHeader: {
                ...styles.pageHeader,
                marginBottom: '1rem',
                paddingBottom: '1rem'
            },
            title: {
                ...styles.title,
                fontSize: '1.5rem'
            },
            formSection: {
                ...styles.formSection,
                padding: '1.5rem'
            },
            dragDropArea: {
                ...styles.dragDropArea,
                padding: '2rem 1rem'
            },
            formActions: {
                ...styles.formActions,
                padding: '1rem',
                justifyContent: 'stretch'
            },
            btnCancel: {
                ...styles.btnCancel,
                flex: 1
            },
            btnSubmit: {
                ...styles.btnSubmit,
                flex: 1
            },
            imagesGrid: {
                ...styles.imagesGrid,
                gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))'
            }
        };
    }
    return styles;
};